import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';

import { registerAlpineComponents } from './alpine-components';

const Drupal = window.Drupal;

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
registerAlpineComponents(Alpine);

Alpine.store('mobileMenu', {
  open: false,
  show() { this.open = true; },
  close() { this.open = false; },
  toggle() { this.open = !this.open; },
});

document.body.addEventListener('htmx:responseError', (event) => {
  const target = event.detail.target;

  if (!target) {
    return;
  }

  target.dispatchEvent(new CustomEvent('ha:htmx-error', {
    bubbles: true,
    detail: event.detail,
  }));
});

const initIfFresh = (el) => {
  if (!(el instanceof Element) || el._x_alpineInitialized) {
    return;
  }
  el._x_alpineInitialized = true;
  Alpine.initTree(el);
};

document.body.addEventListener('htmx:drupal:load', (event) => {
  initIfFresh(event.detail.elt);
});

Drupal.behaviors.htmxAlpine = {
  attach(context) {
    if (context !== document) {
      initIfFresh(context);
    }
  },
};

Alpine.start();
